import { IconButton, InputBase } from '@mui/material';
import { styled } from '@mui/material/styles';

import { fastTransition } from '../../../styles/tokens';

export const Root = styled(InputBase)(({ theme, fullWidth }) => {
  const { color, radius, motion, type, space } = theme.palette.tokens;
  return {
    height: '40px',
    padding: `0 ${space[3]}px`,
    borderRadius: `${radius.control}px`,
    border: `1px solid ${color.borderHairline}`,
    backgroundColor: color.canvas,
    fontSize: `${type.ui.size}px`,
    color: color.textPrimary,
    transition: fastTransition(
      motion,
      'border-color',
      'box-shadow',
      'background-color'
    ),
    '& .MuiInputBase-input': fullWidth
      ? { padding: 0 }
      : {
          width: '200px',
          padding: 0,
          transition: `width ${motion.base} ${motion.easeOut}`,
          [theme.breakpoints.up('md')]: { '&:focus': { width: '280px' } },
        },
    '& input::placeholder': { color: color.textTertiary, opacity: 1 },
    '& .MuiInputAdornment-positionStart .material-symbols-outlined': {
      fontSize: '20px',
      color: color.textTertiary,
    },
    '&:hover': { borderColor: color.borderStrong },
    '&.Mui-focused': {
      borderColor: color.action,
      boxShadow: color.focusRing,
      backgroundColor: color.surface,
    },
    '&.Mui-disabled': {
      color: color.textTertiary,
      backgroundColor: color.n100,
      borderColor: color.borderHairline,
    },
  };
});

export const ClearButton = styled(IconButton)(({ theme }) => ({
  padding: `${theme.palette.tokens.space[1]}px`,
  '& .material-symbols-outlined': {
    fontSize: '18px',
    color: theme.palette.tokens.color.textSecondary,
  },
}));
